import React, { useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useI18n } from '@/i18n/I18nProvider';
import clsx from 'clsx';
import { useAuth } from 'react-oidc-context';
import Spinner from '@/components/ui/spinner';

export default function LoginPage() {
  const { t, locale } = useI18n();
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading && !auth.error) {
      void auth.signinRedirect();
    }
  }, [auth]);

  return (
    <div
      className={clsx(
        'min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8',
        locale === 'ar' && 'direction-rtl'
      )}
    >
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900">{t.login.title}</h1>
          <p className="mt-2 text-gray-600">{t.login.subtitle}</p>
        </div>

        <Card className="mt-8">
          <CardContent className="py-12 flex flex-col items-center justify-center">
            <Spinner />
            {auth.error && <p className="mt-4 text-sm text-red-600 font-medium text-center">{auth.error.message}</p>}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
